import React from 'react';

/** Lazy ClientComputedIframe (not wrapped in a suspense to use the parent widget loading fallback) */
export const ClientComputedIframe = React.lazy(
    () =>
        import(
            /* webpackChunkName: 'widget-iframe' */
            './ClientComputedIframe'
        ),
);
